import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { OktaConfig } from './types';

export function createOktaAuth(config: OktaConfig): OktaAuth {
  const oktaAuthConfig: OktaAuthOptions = {
    issuer: config.issuer,
    clientId: config.clientId,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'email', 'profile', 'Enterprise_IoT_Platform_roles'],
    pkce: true,
  };

  return new OktaAuth(oktaAuthConfig);
}
